import React from "react";
import { Link } from "react-router-dom";

import WaterSupply from "../assets/images/WaterSupply.webp";
import WaterTreat from "../assets/images/Watertreat.webp";

import WWTP from "../assets/images/project/wwtp.webp";
import Townplan from "../assets/images/project/Town_Planning.webp"
import Sump from "../assets/images/project/sump.webp"
import SWDC from "../assets/images/SWDC.webp" 
import Well from "../assets/images/intakewell.webp"

import bridgeHomeImage from "../assets/images/const.webp";

const ProjectCard = ({ title, service, client, image }) => (
  <Link
    to={`/Project/${service.replace(/ /g, "")}/${encodeURIComponent(title)}`}
    className="relative group cursor-pointer overflow-hidden block"
  >
    <img
      src={image}
      alt={title}
      className="w-full h-64 object-cover transition-transform duration-300 group-hover:scale-105"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent">
      <div className="absolute bottom-6 left-6">
        <p className="text-xs text-gray-300 uppercase tracking-wider mb-2">
          {service}
        </p>
        <p className="text-xs text-gray-300 mb-2">{client}</p>
        <h3 className="text-xl text-white font-medium">{title}</h3>
      </div>
    </div>
  </Link>
);

const RecentProjects = () => {
  const allProjects = [
    {
      title: "Work of Construction and Commissioning of Water Supply",
      image: Sump,
      service: "Recent Project",
      client: "Gujarat Industrial Development Corporation",
    },
    {
      title: "Consultancy Services for the Feasibility Study",
      image: WWTP,
      service: "Recent Project",
      client: "STEM Water Distribution & Infrastructure Co. Pvt. Ltd.",
    },
    {
      title: "Survey, Design, DPR",
      image: Townplan,
      service: "Recent Project",
      client: "JMC",
    },
    {
      title: "Services for Water Supply Network",
      image: WaterSupply,
      service: "Recent Project",
      client: "JMC",
    },
    {
      title: "EPC of VMC",
      image: WaterTreat,
      service: "Recent Project",
      client: "VMC",
    },
    {
      title: "Designing, Constructing, Testing & Commissioning of Intake Well",
      image: Well,
      service: "Recent Project",
      client: "VMC",
    },

    {
      title: "PMC Services for Preparation of DPR",
      image: SWDC,
      service: "Recent Project",
      client: "VMC",
    },

    // Add more projects as needed
  ];

  return (
    <div className="max-w-7xl mx-auto px-4 py-16">
      {/* Header */}
      <div className="mb-12">
        <p className="text-sm text-gray-500 uppercase tracking-wider mb-2">
          Innovation & Integrity
        </p>
        <div className="flex justify-between items-end">
          <h2 className="text-3xl font-semibold">Recent Projects</h2>
          <p className="max-w-md text-gray-600">
            We believe that the built environment and buildings we design should
            be a reflection of the aspirations and values of our clients.
          </p>
        </div>
      </div>

      {/* Projects Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {allProjects.map((project, index) => (
          <ProjectCard
            key={index}
            title={project.title}
            service={project.service}
            client={project.client}
            image={project.image}
          />
        ))}
      </div>
    </div>
  );
};

export default RecentProjects;
